module.exports = __webpack_public_path__ + "img/9.67d8b879.png";